/**
 *
 * key
 *
 */


const key = 'ZWNUZWFtU2NoZWR1bGluZw0K'

export default key